// extracted by mini-css-extract-plugin
export var bullet = "_ms-q";
export var bulletText = "_ms-p";
export var bullets = "_ms-k";
export var callout = "_ms-g";
export var calloutBody = "_ms-i";
export var calloutLabel = "_ms-h";
export var checkIcon = "_ms-m";
export var checkList = "_ms-j";
export var checkSvg = "_ms-n";
export var checkText = "_ms-o";
export var fieldCard = "_ms-1";
export var fieldDescription = "_ms-5";
export var fieldHeader = "_ms-3";
export var fieldTitle = "_ms-4";
export var finalNote = "_ms-s";
export var flow = "_ms-x";
export var flowArrow = "_ms-v";
export var flowStep = "_ms-u";
export var helperText = "_ms-r";
export var inlineTitle = "_ms-t";
export var listItem = "_ms-l";
export var noteBody = "_ms-8";
export var noteBodyText = "_ms-9";
export var noteCard = "_ms-2";
export var noteIcon = "_ms-6";
export var noteTitle = "_ms-7";
export var productChoices = "_ms-w";
export var radioDot = "_ms-d";
export var radioDotSelected = "_ms-e";
export var radioDotSvg = "_ms-f";
export var selectableCard = "_ms-b";
export var selectableCardSelected = "_ms-c";
export var strongText = "_ms-a";
export var subHeading = "_ms-0";